module.exports = __webpack_public_path__ + "static/media/warehouse-landing.d9fe2949.jpeg";